export function debouncePromise<Args extends any[], Return>(
    fn: (...args: Args) => Promise<Return> | Return,
    time: number
): (...args: Args) => Promise<Return> {
    let timer: ReturnType<typeof setTimeout> | undefined = undefined;

    return function debounced(...args: Args): Promise<Return> {
        if (timer) {
            clearTimeout(timer);
        }

        return new Promise<Return>((resolve) => {
            timer = setTimeout(() => resolve(fn(...args)), time);
        });
    };
}
